import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import { useMissionTask } from "../../../../providers/MissionTaskProvider";
import { ToggleSurface } from "../../../common/core/Surface";
import { Grid, List } from "@mui/material";
import { useMission } from "../../../../providers/MissionProvider";
import { FormatLocation } from "../../../../common/maphelpers";
import SectionItem from "../../../common/inputs/SectionItem";
import { TaskEnums } from "../../../../common/constants";
import { useMemo } from "react";

const useStyles = makeStyles()(
  (theme) => ({
    list: {
      width: "100%",
      "& a": {
        textDecoration: "none",
        color: "inherit"
      },
      "& .MuiListItemText-primary": {
        fontWeight: 500
      }
    },
  })
);

export default function MissionTaskSectionsCard() {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { mission, missionTask, taskState, hasTransport } = useMissionTask();
  const { orders } = useMission();

  const fileCount = Object.keys(mission.files.uploads).length;
  const validServiceInfo = !!mission.serviceInfo?.serviceCenter;

  const inTransport = hasTransport && taskState >= TaskEnums.State.Arrived;

  const { location, missingAll } = useMemo(() => {
    const wps = missionTask?.route?.waypoints?.filter(t => t?.coordinates?.length === 2);
    if (wps.length === 0) return { location: null, missingAll: true };
    return {
      location: inTransport ? wps?.[wps?.length - 1] : wps?.[0],
      missingAll: wps.length === 0
    };
  }, [missionTask, missionTask?.route?.waypoints, inTransport]);

  return (
    <ToggleSurface
      xs={12}
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <List className={classes.list}>

            <SectionItem
              to="files"
              primary={t("taskSectionsCard:documentation")}
              secondary={fileCount > 1 ? `${fileCount} ${t("taskSectionsCard:pluralFiles")}` : fileCount === 0 ? t("taskSectionsCard:noFiles") : t("taskSectionsCard:singleFile")}
              disableGutters
            />

            <SectionItem
              to="assistance"
              primary={t("taskSectionsCard:assistance")}
              secondary={`${!!location?.address || !!location?.title ? FormatLocation(location) : t(inTransport && !missingAll ? "taskSectionsCard:transportLocationNotAdded" : "taskSectionsCard:assistanceLocationNotAdded")}`}
              disableGutters
            />

            <SectionItem
              to="payment"
              primary={t("taskSectionsCard:payment")}
              secondary={`${orders.length} ${t("taskSectionsCard:orders")}`}
              disableGutters
            />

            <SectionItem
              to="serviceinfo"
              primary={t("taskSectionsCard:serviceInfo")}
              secondary={!mission.serviceInfo ? t("taskSectionsCard:serviceInfoNotAdded") : (validServiceInfo ? `${mission.serviceInfo.serviceCenter || ""} - ${mission.serviceInfo.currentMileage || "0"}KM` : t("taskSectionsCard:serviceInfoEmpty"))}
              disableGutters
            />

            <SectionItem
              to="storage"
              primary={t("taskSectionsCard:storage")}
              secondary={!mission.storageTask ? t("taskSectionsCard:storageNotAdded") : (!!mission.storageTask?.warehouse?.name ? `${t("taskSectionsCard:storageDescription")} - ${mission.storageTask?.warehouse?.name}` : t("taskSectionsCard:storageInfoMissing"))}
              disableGutters
            />

          </List>
        </Grid>
      </Grid>
    </ToggleSurface>
  );
}

